import { topbar } from "../components/topbar";
import './xodim.css';
import tastanova from './images/tastanova.png';
import arofat from './images/arofat.png';
import dano from './images/dano.png';
import gadayev from './images/gadayev.png';
import muhriddin from './images/muhriddin.png';
import muqaddas from './images/muqaddas.png';
import umida from './images/umida.png';
import zilola from './images/zilola.png';
import nargiza from './images/nargiza.png';


export default function Xodimlar()
{
    return(
        <div className="xodimlar">
            {topbar('Xodimlar', 'xodim')}
            <div className="content">
                <br/>
                <div className="chief">
                    <nav className="image-box">
                        <img src={tastanova} alt="Image"/>
                    </nav>
                    <nav className="about-box">
                        <h3>O’quv-uslubiy bo’lim boshlig'i</h3>
                        <p className="chief-name">Tastanova Gulchehra Yeshtayevna</p>
                        <nav>
                            <em>1987-1993 yy. - ikkinchi Toshkent davlat tibbiѐt instituti talabasi</em><br/>
                            <em>1993-2003 yy. - ikkinchi Toshkent davlat tibbiѐt instituti odam anatomiyasi, operativ jarrohlik va topografik anatomiya kafedrasi assistenti</em><br/>
                            <em>2004-2005 yy. - ikkinchi Toshkent davlat tibbiѐt instituti odam anatomiyasi, operativ jarrohlik va topografik anatomiya kafedrasi katta o‘qituvchisi</em><br/>
                            <em>2005-2009 yy. - Toshkent tibbiѐt akademiyasi odam anatomiya, operativ jarrohlik va topografik anatomiyakafedrasi dotsenti</em><br/>
                            <em>2005-2009 yy. - Toshkent tibbiѐt akademiyasi davolash fakulteti dekan muovini</em><br/>
                            <em>2009-2011 yy. - Toshkent tibbiѐt akademiyasi doktoranti</em><br/>
                            <em>2011-2014 yy. - Toshkent tibbiѐt akademiyasi odam anatomiya, operativ jarrohlik va topografik anatomiyakafedrasi dotsenti</em><br/>
                            <em>2014–2017yy. - Toshkent davlat stomatologiya instituti anatomiya kafedrasi dotsenti</em><br/>
                            <em>2017 y. - h.v. - Toshkent davlat stomatologiya instituti anatomiya kafedrasi mudiri</em><br/>
                        </nav>
                        <ul>
                            <li><i className="fa fa-phone"></i><span><b>Telefon</b><p>+998(91) 234-56-78</p></span></li>
                            <li><i className="fa fa-envelope"></i><span><b>Elektron pochta</b><p>info@tsdi.uz</p></span></li>
                            <li><i className="fa fa-graduation-cap"></i><span><b>Ilmiy unvon/daraja</b><p>Tibbiyot fanlari doktori, Dotsent</p></span></li>
                            <li><i className="fa fa-clock-o"></i><span><b>Qabul vaqti</b><p>10:00 - 17:00</p></span></li>
                        </ul>
                    </nav>
                </div>
                <br/>
                <div className="employees">
                    
{/* -------------------------------------------- */}

                    <div class="divide-employee"></div>

{/* --------------------------------------------- */}

                    <div className="employee">
                        <nav className="image-box">
                            <img src={gadayev} alt="Image"/>
                        </nav>
                        <nav className="about-box">
                            <h3>Ta’limning kredit tizimini boshqarish sektorida bosh mutaxassis</h3>
                            <p className="employe-name">Gadayev Asliddin Mamarasulovich</p>
                            <ul>
                                <li><i className="fa fa-phone"></i><span><b>Telefon</b><p>+998(97) 733-36-34</p></span></li>
                                <li><i className="fa fa-envelope"></i><span><b>Elektron pochta</b><p>gadayevasliddin71@gmail.com</p></span></li>
                                <li><i className="fa fa-gavel"></i><span><b>Mas`ul</b><p>Dars jadvallarini yaratish va kredit modul faoliyatiga mas’ul</p></span></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="employee">
                        <nav className="image-box">
                            <img src={muhriddin} alt="Image"/>
                        </nav>
                        <nav className="about-box">
                            <h3>Ta’limning kredit tizimini boshqarish sektorida bosh mutaxassis</h3>
                            <p className="employe-name">Sherboboyev Muxriddin Azimmurod o'g'li</p>
                            <ul>
                                <li><i className="fa fa-phone"></i><span><b>Telefon</b><p>+998(90) 250-47-10</p></span></li>
                                <li><i className="fa fa-envelope"></i><span><b>Elektron pochta</b><p>mshermomoyev@bk.ru</p></span></li>
                                <li><i className="fa fa-gavel"></i><span><b>Mas`ul</b><p>O’quv ishlari bo’yicha prorector texnik ishlariga yordamchi </p></span></li>
                            </ul>
                        </nav>
                    </div>
                    
                    <div className="employee">
                        <nav className="image-box">
                            <img src={dano} alt="Image"/>
                        </nav>
                        <nav className="about-box">
                            <h3>Ta’limning kredit tizimini boshqarish sektorida etakchi mutaxassis</h3>
                            <p className="employe-name">Axmadaliyeva Dano Toganovna</p>
                            <ul>
                                <li><i className="fa fa-phone"></i><span><b>Telefon</b><p>+998(99) 814-10-58</p></span></li>
                                <li><i className="fa fa-envelope"></i><span><b>Elektron pochta</b><p>dono_69@mail.ru</p></span></li>
                                <li><i className="fa fa-gavel"></i><span><b>Mas`ul</b><p>O’quv-uslubiy ishlarga mas’ul </p></span></li>
                            </ul>
                        </nav>
                    </div>

{/* -------------------------------------------- */}

                    <div class="divide-employee"></div>

{/* --------------------------------------------- */}

                    <div className="employee">
                        <nav className="image-box">
                            <img src={muqaddas} alt="Image"/>
                        </nav>
                        <nav className="about-box">
                            <h3>Akademik litsey va texnikumlarga metodik yordam berish sektori bosh mutaxassisi</h3>
                            <p className="employe-name">Xusanova Muqaddas Aktamovna</p>
                            <ul>
                                <li><i className="fa fa-phone"></i><span><b>Telefon</b><p>+998(91) 234-56-78</p></span></li>
                                <li><i className="fa fa-envelope"></i><span><b>Elektron pochta</b><p>info@tsdi.uz</p></span></li>
                                <li><i className="fa fa-gavel"></i><span><b>Mas`ul</b><p>Akademik litsey va texnikumlar bilan ishlash va ular bilan faoliyat olib borishga mas’ul</p></span></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="employee">
                        <nav className="image-box">
                            <img src={nargiza} alt="Image"/>
                        </nav>
                        <nav className="about-box">
                            <h3>Uslubchi</h3>
                            <p className="employe-name">Zakirova Nargiza Xolmatovna</p>
                            <ul>
                                <li><i className="fa fa-phone"></i><span><b>Telefon</b><p>+998(91) 234-56-78</p></span></li>
                                <li><i className="fa fa-envelope"></i><span><b>Elektron pochta</b><p>info@tsdi.uz</p></span></li>
                                <li><i className="fa fa-gavel"></i><span><b>Mas`ul</b><p>Talabalar hujjatlarini saqlash, talabalarga oid buyruqlar bilan ishlash</p></span></li>
                            </ul>
                        </nav>
                    </div>
                    
                    <div className="employee">
                        <nav className="image-box">
                            <img src={zilola} alt="Image"/>
                        </nav>
                        <nav className="about-box">
                            <h3>O’quv ishlari bo’yicha inspektor</h3>
                            <p className="employe-name">Aslonova Zilola Mamir qizi</p>
                            <ul>
                                <li><i className="fa fa-phone"></i><span><b>Telefon</b><p>+998(91) 234-56-78</p></span></li>
                                <li><i className="fa fa-envelope"></i><span><b>Elektron pochta</b><p>info@tsdi.uz</p></span></li>
                                <li><i className="fa fa-gavel"></i><span><b>Mas`ul</b><p>Talabalar hujjatlarini saqlash, talabalarga oid buyruqlar bilan ishlash</p></span></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="employee">
                        <nav className="image-box">
                            <img src={arofat} alt="Image"/>
                        </nav>
                        <nav className="about-box">
                            <h3>Dispecher</h3>
                            <p className="employe-name">Tuxtaeva Arofat Saidmurod qizi</p>
                            <ul>
                                <li><i className="fa fa-phone"></i><span><b>Telefon</b><p>+998(91) 234-56-78</p></span></li>
                                <li><i className="fa fa-envelope"></i><span><b>Elektron pochta</b><p>info@tsdi.uz</p></span></li>
                                <li><i className="fa fa-gavel"></i><span><b>Mas`ul</b><p>O’quv-uslubiy bo’lim xujjat ishlari bo’yicha yordamchi</p></span></li>
                            </ul>
                        </nav>
                    </div>

                </div>
            </div>
        </div>
    )
}